import { useContext } from 'react';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';

import { BULK_ACTIONS_RESOURCES, PAGE_NAMES } from 'constant';
import useService from '../utils/useService';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setShowLoader, setForceUpdateRows, setConfirmationDialog } = params;
	const { showAlert } = useContext(AppContext);
	const { executeBulkRefund, executeBulkRefundV2 } = useService();

	switch (action.id) {
		case 'add':
			return () => {
				history.push({
					pathname: `/${PAGE_NAMES.bulkActions}/${BULK_ACTIONS_RESOURCES.bulkRefund}/create`
				});
			};
		case 'executeBulkRefundV2': {
			const toggleIsDisabled = async () => {
				setShowLoader(true);
				try {
					await executeBulkRefundV2(rowData._id, rowData.description, rowData.gameName);
					showAlert('Bulk refund request submitted successfully. Results will be available in some time.');
					setForceUpdateRows(true);
				} catch (error: any) {
					showAlert(`Error: ${error?.response?.data?.error}`, { type: 'error' });
				}
				setShowLoader(false);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Please Confirm',
					message: 'Are you sure you want to bulk refund ?',
					handleAlertConfirmation: toggleIsDisabled
				});
			};
		}
		case 'executeBulkRefund': {
			const toggleIsDisabled = async () => {
				setShowLoader(true);
				try {
					await executeBulkRefund(rowData._id, rowData.description, rowData.gameName);
					showAlert('In processing, please check after some time');
					setForceUpdateRows(true);
				} catch (error: any) {
					showAlert(`Error: ${error?.response?.data?.error}`, { type: 'error' });
				}
				setShowLoader(false);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Please Confirm',
					message: 'Are you sure you want to bulk refund ?',
					handleAlertConfirmation: toggleIsDisabled
				});
			};
		}
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
